/* eslint-disable */
// AWS Amplify configuration - uses environment variables for Vercel deployment

const awsmobile = {
    "aws_project_region": process.env.REACT_APP_AWS_REGION || "us-east-1",
    "aws_cognito_identity_pool_id": process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
    "aws_cognito_region": process.env.REACT_APP_AWS_REGION || "us-east-1",
    "aws_user_pools_id": process.env.REACT_APP_USER_POOLS_ID,
    "aws_user_pools_web_client_id": process.env.REACT_APP_USER_POOLS_WEB_CLIENT_ID,
    "oauth": {},
    "aws_user_files_s3_bucket": process.env.REACT_APP_S3_BUCKET,
    "aws_user_files_s3_bucket_region": process.env.REACT_APP_AWS_REGION || "us-east-1"
};

export default awsmobile;

